import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // If not logged in and this isn't an admin-only route, open the login modal
    if (!loading && !user && requiredRole !== 'admin') {
      window.dispatchEvent(new CustomEvent('openLoginModal'));
    }
  }, [loading, user, requiredRole]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    // Admin route still redirects to admin-login page; regular users get modal + go home
    if (requiredRole === 'admin') {
      return <Navigate to="/admin-login" replace />;
    }
    // Return to the page they came from (or home) while modal opens
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
